import React, { useContext } from 'react';
import ImpersonatorContext from '../../../../contexts/ImpersonatorContext';
import useUser from '../../../../hooks/useUser';
import styled from 'styled-components';
import Icon from '../../../../kingpin/atoms/Icon';
import Typography from '../../../../kingpin/atoms/Typography';
import userTypeCheckers from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UsersProvider/userTypeCheckers';
import Button from '../../../../kingpin/atoms/Button';
import Row from 'components/Common/Row';
import { Z_INDEX } from '../../../../constants';

const OverlayDiv = styled.div`
  border: 1px solid var(--color-badge-warning-border);
  border-radius: 8px;
  background-color: var(--color-badge-warning-bg);
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  min-width: 324px;
  z-index: ${Z_INDEX.VIEWING_APP_AS};
`;

const ViewingAppAsOverlay = () => {
  const { impersonatorId, stopImpersonation } = useContext(ImpersonatorContext);
  const { user } = useUser(impersonatorId);

  if (!impersonatorId || !user || userTypeCheckers.isWallboardUser(user)) {
    return null;
  }

  return (
    <OverlayDiv>
      <Row centerAlign style={{ gap: 8 }}>
        <Icon icon={'info'} />
        <Typography.Body type={'Label'} isEllipsis>
          {`Viewing as: ${user.displayName}`}
        </Typography.Body>
      </Row>
      <Row centerAlign style={{ gap: 8 }}>
        <div style={{ opacity: 0 }}>
          <Icon icon={'info'} />
        </div>
        <Button
          size={'Small'}
          type={'Secondary'}
          label={'Dismiss'}
          onClick={stopImpersonation}
        />
      </Row>
    </OverlayDiv>
  );
};

export default ViewingAppAsOverlay;
